import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const HideIconSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.9394 21.6367C18.2424 22.9094 16.8041 23.3337 14 23.3337C5.83329 23.3337 1.16663 14.0003 1.16663 14.0003C1.16663 14.0003 2.12117 11.8791 3.81814 9.7579M22.4848 19.5155C25.583 16.8297 26.8333 14.0003 26.8333 14.0003C26.8333 14.0003 22.1666 4.66699 14 4.66699C10.7253 4.66699 8.01332 5.83882 5.93935 7.63669" stroke="currentColor" strokeWidth="1.56" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.8788 11.306C13.0227 9.74779 15.2132 9.4119 16.7714 10.5558C18.3296 11.6997 18.6655 13.8901 17.5216 15.4483" stroke="currentColor" strokeWidth="1.56" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14.4242 16.9692C12.7272 16.9692 11.4545 16.1208 11.0302 14.4237" stroke="currentColor" strokeWidth="1.56" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M0.848511 4.24219L27.1515 23.7573" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const HideIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={HideIconSvg} {...props} />
);